import { GoogleFont } from "./google-font";

customElements.define("google-font", GoogleFont);
